import { useState, useEffect, createContext, useContext } from "react";
import {
  getCases,
  activateCase,
  deleteCase,
  saveCase,
  sendCompanySearch,
} from "../api/cases";
import { apiConfig } from "../api/AxiosClient";

const CompanyContext = createContext(null);

export function CompanyProvider({ children }) {
  const [companies, setCompanies] = useState([]);
  const [currentCompany, setCurrentCompany] = useState(null);
  const [companyKey, setCompanyKey] = useState(0);
  const [showAddCompany, setShowAddCompany] = useState(false);

  const selectCompany = (company) => {
    setCurrentCompany(company);
    apiConfig.target = company?.target ?? null;
    setCompanyKey((k) => k + 1);
  };

  const refreshCompanies = async () => {
    const res = await getCases();
    setCompanies(res.data);
    return res.data;
  };

  const toggleCompany = async (company, activate) => {
    await activateCase(company.target, activate);
    setCompanies((prev) =>
      prev.map((c) =>
        c.case === company.target ? { ...c, active: activate } : c,
      ),
    );
  };

  const removeCompany = async (company) => {
    await deleteCase(company.target);
    setCompanies((prev) => prev.filter((c) => c.case !== company.case));
    if (currentCompany?.case === company.case) {
      const remaining = companies.filter((c) => c.case !== company.case);
      selectCompany(remaining[0] ?? null);
    }
  };

  const addCompany = async (result) => {
    console.log(result);
    await saveCase(result.name ?? result.case, result.domain ?? result.url);
    await refreshCompanies();
  };

  const searchCompanies = async (query) => {
    const res = await sendCompanySearch(query);
    return res?.data ?? [];
  };

  useEffect(() => {
    getCases().then((res) => {
      setCompanies(res.data);
      selectCompany(res.data[0] ?? null);
    });
  }, []);

  return (
    <CompanyContext.Provider
      value={{
        companies,
        setCompanies,
        currentCompany,
        companyKey,
        selectCompany,
        refreshCompanies,
        toggleCompany,
        removeCompany,
        addCompany,
        searchCompanies,
        showAddCompany,
        setShowAddCompany,
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
}

export function useCompanyContext() {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error("useCompanyContext must be used within a CompanyProvider");
  }
  return context;
}
